import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const NewMessageModal = ({ clients, onClose, onSend }) => {
  const [formData, setFormData] = useState({
    clientId: '',
    communicationType: 'email',
    subject: '',
    message: '',
  });
  const [sending, setSending] = useState(false);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();

    if (!formData?.clientId || !formData?.message?.trim()) {
      alert('Veuillez remplir tous les champs requis');
      return;
    }

    try {
      setSending(true);
      await onSend(formData);
      onClose();
    } catch (error) {
      console.error('Error sending message:', error);
      alert('Erreur lors de l\'envoi du message');
    } finally {
      setSending(false);
    }
  };

  const clientOptions = clients?.map(client => ({
    value: client?.id,
    label: `${client?.fullName || client?.full_name} - ${client?.email}`,
  })) || [];

  const typeOptions = [
    { value: 'email', label: 'Email' },
    { value: 'phone', label: 'Appel téléphonique' },
    { value: 'meeting', label: 'Réunion' },
    { value: 'chat', label: 'Message instantané' },
  ];

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-xl border border-border max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="p-6 border-b border-border flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
              <Icon name="MessageSquare" size={20} className="text-primary" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-foreground">Nouveau Message</h2>
              <p className="text-sm text-muted-foreground">Envoyer un message à un client</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          {/* Client Selection */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Client <span className="text-error">*</span>
            </label>
            <Select
              options={[{ value: '', label: 'Sélectionner un client' }, ...clientOptions]}
              value={formData?.clientId}
              onChange={(e) => handleChange('clientId', e?.target?.value)}
              required
            />
          </div>

          {/* Communication Type */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Type de communication <span className="text-error">*</span>
            </label>
            <Select
              options={typeOptions}
              value={formData?.communicationType}
              onChange={(e) => handleChange('communicationType', e?.target?.value)}
              required
            />
          </div>

          {/* Subject */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Sujet
            </label>
            <Input
              placeholder="Sujet du message"
              value={formData?.subject}
              onChange={(e) => handleChange('subject', e?.target?.value)}
            />
          </div>

          {/* Message */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Message <span className="text-error">*</span>
            </label>
            <textarea
              placeholder="Tapez votre message ici..."
              value={formData?.message}
              onChange={(e) => handleChange('message', e?.target?.value)}
              required
              rows={6}
              className="w-full px-4 py-3 bg-background border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          {/* Actions */}
          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              disabled={sending}
              className="flex-1"
            >
              Annuler
            </Button>
            <Button
              type="submit"
              disabled={sending || !formData?.clientId || !formData?.message?.trim()}
              className="flex-1"
            >
              {sending ? (
                <>
                  <Icon name="Loader" size={20} className="mr-2 animate-spin" />
                  Envoi...
                </>
              ) : (
                <>
                  <Icon name="Send" size={20} className="mr-2" />
                  Envoyer
                </>
              )}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewMessageModal;
